webpackJsonp([91098348849845],{

/***/ 462:
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"postBySlug": {
				"html": "<p>Using Redux in Flutter is as easy as installing the dependancy libraries. We'll be using the Dart <a href=\"https://pub.dartlang.org/packages/redux\">redux</a> package as well as the <a href=\"https://pub.dartlang.org/packages/flutter_redux\">Flutter Redux</a> packacge.</p>\n<p>Open up your <code>pubspec.yaml</code> file and add the dependencies. Your dependency section will look like this, starting on line 4:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-yaml\"><code>// pubspec.yaml\n<span class=\"token punctuation\">...</span>\n\n<span class=\"token key atrule\">dependencies</span><span class=\"token punctuation\">:</span>\n  <span class=\"token key atrule\">flutter</span><span class=\"token punctuation\">:</span>\n    <span class=\"token key atrule\">sdk</span><span class=\"token punctuation\">:</span> flutter\n  <span class=\"token key atrule\">redux</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\">=2.0.0 &lt;3.0.0\"</span>\n  <span class=\"token key atrule\">flutter_redux</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\">=0.3.0 &lt;0.4.0\"</span>\n  <span class=\"token key atrule\">redux_logging</span><span class=\"token punctuation\">:</span> ^0.1.4\n\n<span class=\"token punctuation\">...</span>\n</code></pre>\n      </div>\n<p>Now in your terminal:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-none\"><code>flutter packages get</code></pre>\n      </div>",
				"frontmatter": {
					"title": "Flutter Redux Setup"
				},
				"fields": {
					"slug": "/flutter-redux-setup"
				}
			}
		},
		"pathContext": {
			"slug": "/flutter-redux-setup"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---flutter-redux-setup-ccff01086219574f192b.js